// extracted by mini-css-extract-plugin
module.exports = {"cardLink":"cardLink___1_sxd","infoCard":"infoCard___2OlFA","links":"links___2RJ4M"};